module.exports = __webpack_public_path__ + "public/PLAKAT-OGO_LNY.a165d6b1.pdf";